import { render, staticRenderFns } from "./CurrentTarget.vue?vue&type=template&id=2372a3e0&scoped=true&"
import script from "./CurrentTarget.vue?vue&type=script&lang=js&"
export * from "./CurrentTarget.vue?vue&type=script&lang=js&"
import style0 from "./CurrentTarget.vue?vue&type=style&index=0&id=2372a3e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2372a3e0",
  null
  
)

export default component.exports